import { Component, OnInit, ViewChild } from '@angular/core';

import { ArkUnitOfWork, AuthService, AppInformationService } from '../../core/core.module';
import { CustomStore, BreezeDxStoreService } from 'app/core/core.module';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { Predicate } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SentsDialogComponent } from '../sents-dialog.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-messages-texts',
    templateUrl: './texts.component.html',
    styleUrls: ['./texts.component.scss'],
    imports: [DevExtremeModule],
})
export class TextsComponent implements OnInit {
    store: CustomStore;
    mode: string;
    onToolbarPreparing = SharedModule.onToolbarPreparing;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private storeService: BreezeDxStoreService,
        private route: ActivatedRoute,
        private router: Router,
        public auth: AuthService,
        public appInfo: AppInformationService,
        private modalService: BsModalService,
    ) {}

    async ngOnInit() {
        this.mode = this.route.snapshot.data['mode'];
        this.getStore();
    }

    getStore() {
        let predicate = null;
        if (!this.auth.hasRole('Administrator')) predicate = new Predicate('fromUserId', '==', this.auth.currentUser.id);
        const query = this.uow.textMessages.baseQuery().where(predicate).expand('textGroupLinks.toGroup, fromUser');
        this.store = this.storeService.createStore(this.uow, this.uow.textMessages, query, 'id', 'created desc');
    }

    add() {
        this.router.navigate(['new'], { relativeTo: this.route });
    }

    async openSents(message: any) {
        const modalRef = this.modalService.show(SentsDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                messageId: message.id,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result) {
            }
        });
    }
}
